const translations = {
    assetModelSelectorLabel: 'Asset model',
    battery: 'Exedy Battery',
    drone: 'Exedy Drone'
};

export default translations;
